import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["popupContainer", "popupContent"];

    connect() {
        this.element.addEventListener("htmx:afterSwap", this.handleAfterSwap.bind(this));
    }

    open(event) {
        if (event) event.preventDefault();
        if (this.hasPopupContainerTarget) {
            this.popupContainerTarget.classList.remove('hidden'); 
            this.popupContainerTarget.classList.add('flex');
            document.body.classList.add("overflow-hidden");
        }
    }

    close(event) {
        if (event) event.preventDefault();
        if (this.hasPopupContainerTarget) {
            this.popupContainerTarget.remove();
        }
        if (this.hasPopupContentTarget) {
            this.popupContentTarget.innerHTML = "";
        }
        document.body.classList.remove('overflow-hidden');
    }

    hide(event) {
        if (event) event.preventDefault();
        if (this.hasPopupContainerTarget) {
            this.popupContainerTarget.classList.remove('flex'); 
            this.popupContainerTarget.classList.add('hidden'); 
        }
        document.body.classList.remove('overflow-hidden');
    }

    disconnect() {
        document.body.classList.remove('overflow-hidden');
    }

    handleAfterSwap(event) {
        if (this.hasPopupContentTarget && event.detail.target === this.popupContentTarget) {
        }
    }
}